import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@linaria/react';
const Article = (props) => {
  const { isPost, showHero, children, theme } = props;

  return (
    <React.Fragment>
      <ArticleStyled {...props}>{children}</ArticleStyled>
    </React.Fragment>
  );
};

Article.defaultProps = {
  isPost: false,
  showHero: true,
};

Article.propTypes = {
  isPost: PropTypes.bool,
  showHero: PropTypes.bool,
  children: PropTypes.node.isRequired,
  theme: PropTypes.object.isRequired,
};

export default Article;

const ArticleStyled = styled.article`
  padding: ${(props) => props.theme.space.inset.default};
  margin: 0 auto;

  @media (min-width: 768px) {
      padding: calc(${(props) => props.theme.space.default}) calc(${(props) =>
  props.theme.space.default} * 2);
      max-width: ${(props) => props.theme.text.maxWidth.tablet};
  }
  @media (min-width: 1024px) {
      padding: ${(props) =>
        props.isPost && (props.showHero === null || props.showHero !== false)
          ? `calc(${props.theme.space.default} * 2 ) 0 calc(${props.theme.space.default} * 2)`
          : `calc(${props.theme.space.default} * 2 + 90px) 0 calc(${props.theme.space.default} * 2)`};
      max-width: ${(props) => props.theme.text.maxWidth.desktop};
  }
  @media (min-width: 1440px)  {
      max-width: ${(props) => props.theme.text.maxWidth.desktopL};
  }
  @media (min-width: 1800px)
      max-width: ${(props) => props.theme.text.maxWidth.desktopL};
  }
  @media (min-width: 2560px)
      max-width: ${(props) => props.theme.text.maxWidth.desktopL};
  }
`;
